import { cn } from '@/utils/cn';
import React from 'react';
import { APPLY } from '@/constants';
import Button from '../Button';
import ButtonLabel from '../Typography/ButtonLabel';

function ProductFilterButtons({
  isResetDisabled,
  handleFilterReset,
  handleApply,
  showForCampaign = false,
  isApplyDisabled = true,
}) {
  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 bg-white flex justify-center gap-[10px] lg:gap-[16px] px-20 lg:px-40 py-12 shadow-job-search-filter',
        showForCampaign && 'lg:hidden',
      )}
    >
      <Button
        type="outline"
        className={cn('w-1/2 h-[40px] lg:h-[36px] max-w-[200px] ', {
          '!bg-aquarelle-purple !border-himalayan-poppy': isResetDisabled,
          '!border-pacific-queen': !isResetDisabled,
        })}
        onClick={handleFilterReset}
        disabled={isResetDisabled}
      >
        <ButtonLabel
          label="Reset"
          className={cn('text-sm lg:text-base text-pacific-queen font-bold', {
            'text-atelier': isResetDisabled,
          })}
        />
      </Button>

      <Button
        type="primary"
        className={cn(
          'w-1/2 h-[40px] lg:h-[36px] max-w-[200px] !bg-pacific-queen border-transparent border',
          {
            '!bg-aquarelle-purple !border-himalayan-poppy': isApplyDisabled,
          },
        )}
        onClick={() => handleApply(APPLY)}
      >
        <ButtonLabel
          label="Apply"
          className={cn('text-sm lg:text-base text-white font-bold', {
            'text-atelier': isApplyDisabled,
          })}
        />
      </Button>
    </div>
  );
}

export default ProductFilterButtons;
